import { useTexts } from "../../hooks";
import { getClasses } from "../../utils";
import Modal, { ModalProps } from "./Modal";
import classes from "../../styles/Modal.module.css";
import Rounds from "../history/Rounds";

// History is a reserved word
const HistoryModal: React.FC<ModalProps> = (props) => {
  const { common } = useTexts();

  return (
    <Modal
      className={getClasses(
        classes,
        "history",
        "fullscreen",
        "fixed",
        "message"
      )}
      shown={props.shown}
      icon="Info"
      title={common.history}
    >
      <Rounds />
    </Modal>
  );
};

export default HistoryModal;
